import React, { useEffect, useState } from 'react';
import Button from '../Button/Button';
import Input from '../Input/Input';

interface DailogProps {
  title: string;
  isDeletePopup: boolean;
  setIsPopupOpen: (arg: boolean) => void;
  onConfirm: () => void;
  type?: string;
  fliterVal?: string;
}

const Dailog = (props: DailogProps) => {
  const { setIsPopupOpen, title, onConfirm, isDeletePopup, type, fliterVal } = props;
  const [state, setState] = useState('');
  const [error, setError] = useState<string | undefined>();

  const onConfirmValidation = () => {
    if (state.toLowerCase() === (!type?.trim() ? 'delete' : type.trim())) {
      setError(undefined);
      onConfirm();
    } else {
      setError(`Please enter ${type ? type : 'delete'}`);
    }
  };

  const deleteCancel = () => {
    setIsPopupOpen(false);
    setError(undefined);
    setState('');
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      onConfirmValidation();
    }
  };
  useEffect(() => {
    if (isDeletePopup === false) {
      setState('');
    }
  }, [isDeletePopup]);
  return (
    <>
      {isDeletePopup && (
        <>
          <div
            className="fixed z-[60] inset-0 flex items-center justify-center"
            onClick={() => deleteCancel()}
            data-testid="dailog-wrapper"
          >
            <div
              className="bg-white w-full p-4 m-2 md:w-1/3 rounded-lg shadow-lg relative"
              onClick={(e) => e.stopPropagation()}
            >
              <div
                className="absolute -top-3 flex items-center font-bold justify-center -right-2 text-white rounded-full h-6 w-6 bg-black hover:bg-red-500 cursor-pointer"
                onClick={() => deleteCancel()}
              >
                <i className="fa-solid fa-x text-[13px]"></i>
              </div>
              <div className="text-lg font-semibold text-center mb-2">
                <i
                  className={`fa-solid text-[30px] ${
                    type === 'recrawl' || type === 'update'
                      ? 'fa-recycle text-green-500'
                      : type === 'generate'
                      ? 'fa-file-arrow-down text-green-500'
                      : type === 'reviewed'
                      ? 'fa-square-check text-green-500'
                      : type === 'archive'
                      ? 'fa-solid fa-box-archive text-green-500'
                      : ' fa-trash-can text-red-500'
                  }`}
                ></i>
              </div>

              <div className="text-center font-semibold text-lg text-black">
                {type === 'update'
                  ? 'Updating this setting may result in loss of organization data.'
                  : type === 'generate' && title==='Keywords'
                  ? 'Generating Keywords document'
                  : type === 'generate' && title==='Site'
                  ? 'Generating Site Report'
                  : type === 'generate'
                  ? `Generating DMCA document for ${fliterVal} weblinks.`
                  : type === 'reviewed'
                  ? title
                  : type === 'archive'
                  ? 'Are you sure you want to archive all the weblinks ?'
                  : `Are you sure you want to ${
                      type ? type : 'delete'
                    } this ${title} ?`}{' '}
              </div>

              <div className="my-5 text-center text-black">
                <div className="text-sm font-semibold mb-2">
                  Type{' '}
                  <span className="font-bold text-base text-red-500">{`${
                    type ? type : 'delete'
                  }`}</span>{' '}
                  to Confirm
                </div>
                <div className="flex justify-center">
                  <Input
                    placeholder={''}
                    type={'text'}
                    onChange={(e) => setState(e.target.value)}
                    error={error}
                    value={state}
                    handleEnterKeyPress={handleKeyDown}
                    className="text-center"
                  />
                </div>
              </div>
              <div className="flex justify-center gap-3 ">
                <Button
                  label="Confirm"
                  buttonType="primary"
                  type="button"
                  onClick={onConfirmValidation}
                  disabled={state.toLowerCase() !== (type ? type : 'delete')}
                />
                <Button
                  label="Cancel"
                  buttonType="danger"
                  type="button"
                  onClick={() => deleteCancel()}
                />
              </div>
            </div>
          </div>
          <div className="opacity-75 fixed inset-0 z-50 bg-[#18315380]"></div>
        </>
      )}
    </>
  );
};

export default Dailog;
